
import React from 'react';
import './Notfound.css';


const NotFound = () => {
    return (
        <div className="">
          <div className="NotFound-banner">
         </div>
        </div>
    );
};

export default NotFound;